import { render, staticRenderFns } from "./ProductosForm.vue?vue&type=template&id=a8307bf0"
import script from "./ProductosForm.vue?vue&type=script&lang=js"
export * from "./ProductosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports